// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3yPPx","name":"Header_name__24Gwu","birthday":"Header_birthday__1vQkG","skeleton":"Header_skeleton__3t7Ax"};